import React, { useEffect } from 'react'
import { connect } from 'react-redux'

import ReactTooltip from 'react-tooltip'
import { useFormContext } from 'react-hook-form'

import { colors } from 'styles/colors'

import SwitchButton from './SwitchButton'
import { withMobile } from 'utils/mobile'
import PatTooltip from './tooltip/PatTooltip'

import {
    Container,
    Panel,
    ClickableContainer,
    SwitchText
} from './PatSwitch.style'
import { openPatModal } from 'store/actions/home'

const PatSwitch = ({
    name,
    mobile,
    onChange = () => {},
    defaultValue = false,
    color = colors.defaultGreen,
    className,
    ...otherProps
}) => {
    const { watch, setValue, register, unregister } = useFormContext()

    useEffect(() => {
        register(name)
        return () => unregister(name)
    }, [name, register, unregister])

    useEffect(() => {
        setValue(name, defaultValue)
    }, [name, defaultValue, setValue])

    useEffect(() => {
        ReactTooltip.rebuild()
    })

    const handleChange = (e) => {
        const checked = e.target.checked
        onChange(checked, () => setValue(name, checked))
    }

    const { openPatModal } = otherProps

    return (
        <Container className={className} {...otherProps}>
            <Panel>
                <SwitchText>PAT</SwitchText>
                <SwitchButton
                    checked={!!watch(name)}
                    onChange={handleChange}
                    width="48"
                    height="25"
                    color={colors.lime}
                />
                <ClickableContainer
                    data-testid="clickable-container"
                    data-for="patTooltip"
                    data-tip="whatIsPat"
                    onClick={openPatModal}
                >
                    <i>&#63;</i>
                </ClickableContainer>
            </Panel>
            {!mobile && (
                <ReactTooltip
                    id="patTooltip"
                    effect="solid"
                    place="top"
                    backgroundColor={color}
                    getContent={() => <PatTooltip $color={color} />}
                />
            )}
        </Container>
    )
}

const mapDispatchToProps = (dispatch) => ({
    openPatModal: () => dispatch(openPatModal())
})

export default withMobile(connect(null, mapDispatchToProps)(PatSwitch))
